import React from 'react'
import { Box, Card, CardContent, Typography, IconButton } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { useFormFactor } from '../../../hooks'
import { useScrollableRails } from '../hooks/useScrollableRails'
import { HomeRailsScrollableContainer } from './home-rails-scrollable-container'

export const HomeRails = ({
  title,
  items,
  renderItem,
  exploreMoreCta,
  dataTest
}) => {
  const { isMobile } = useFormFactor()
  const {
    scrollContainerRef,
    canScrollLeft,
    canScrollRight,
    hasScrollableContent,
    scrollLeft,
    scrollRight,
    updateScrollState
  } = useScrollableRails(items)

  const renderTitle = typeof title === 'string'
    ? <Typography sx={{ fontWeight: 700 }}>{title}</Typography>
    : title

  return (
    <Card data-test={dataTest}>
      <CardContent sx={{ m: 0, p: 0 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, backgroundColor: '#FBFBFB', borderBottom: '1px solid #E0E0E0' }}>
          {renderTitle}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', mt: 2, mb: 2 }} gap={1}>
          {!isMobile && <Box>{exploreMoreCta}</Box>}
          {!isMobile && hasScrollableContent && (
            <Box display='flex' alignItems='center' justifyContent='end' data-test={`${dataTest}-scroll-buttons-container`}>
              {/* Left scroll arrow */}
              <IconButton
                onClick={scrollLeft}
                size='small'
                data-test={`${dataTest}-scroll-left-button`}
                disabled={!canScrollLeft}
              >
                <ChevronLeft />
              </IconButton>

              {/* Right scroll arrow */}
              <IconButton
                onClick={scrollRight}
                size='small'
                data-test={`${dataTest}-scroll-right-button`}
                disabled={!canScrollRight}
              >
                <ChevronRight />
              </IconButton>
            </Box>
          )}
        </Box>

        <Box sx={{ position: 'relative', p: 2 }}>

          {/* Horizontal scrollable content */}
          <HomeRailsScrollableContainer
            scrollContainerRef={scrollContainerRef}
            onScroll={updateScrollState}
            dataTest={`${dataTest}-scrollable-container`}
          >
            {items.map((item, itemIndex) => (
              <Box
                key={item?.sk || itemIndex}
                sx={{
                  minWidth: 300,
                  maxWidth: 300,
                  flexShrink: 0
                }}
              >
                {renderItem(item, itemIndex)}
              </Box>
            ))}
          </HomeRailsScrollableContainer>
          {isMobile && (
            <Box sx={{ mt: 2 }}>
              {exploreMoreCta}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  )
}
